import Request from '../../../../src/core/gd/data/request'
import {PinData, PinLocation} from "../../model2/pin/@types"

export default class ApiPins {

    constructor() {}

    addPin(data: PinData) {
        return new Request(this,'POST','pins',{
            projectId       : data.projectId,
            taskId          : data.taskId,
            userId          : data.userId,
            companyId       : data.organizationId,
            customViewId    : data.customViewId,
            documentId      : data.documentId,

            location        : data.location,
        })
    }

    removePin(id: ID) {
        return new Request(this,'DELETE','pin/'+id)
    }

    updatePin(id: ID, location: PinLocation) {
        return new Request(this,'PUT','pin/'+id,{
            location: location,
        })
    }
}